<template>
    <!--
    Dropdown component
    Styled dropdown component.

    @property {Object} items, items to show
    @property {Number} select, (default null) index of default selected item
    @property {String} style, style class to modify component
    -->
    <div class="dropdown" :class="classObject">

        <span class="label" v-if="label">{{ label }}</span>

        <div>
            <icon name="chevron_down" viewBox="0 0 24 24" />

            {{ display }}

            <select v-model="selected" @change="selectItem(selected)" v-if=" ! grouped" @focus="focusHandler" @blur="blurHandler" :disabled="disabled">
                <option v-if="showDefault" :disabled="!keepDefault" :value="null">{{ defaultValue }}</option>
                <option v-for="(label, val) in items" :value="val">{{ label }}</option>
            </select>

            <select v-model="selected" @change="selectItem(selected)" v-else @focus="focusHandler" @blur="blurHandler" :disabled="disabled">
                <optgroup :label="key" v-for="(options, key) in items">
                    <option v-for="option in options" :value="option.value">{{ option.label }}</option>
                </optgroup>
            </select>
        </div>
    </div>
</template>

<script>
export default
{
    name: 'Dropdown',

    data() {
        return {
            open: false,
            selected: '',
            style: 'dropdown--framed',
        }
    },

    props:
    {
        items:
        {
            type: [Object, Array],
            default: []
        },

        select:
        {
            type: [String, Number, Date],
            default: null
        },

        noBorder:
        {
            type: Boolean,
            default: false,
        },

        label:
        {
            type: [String, Number, Date],
        },

        grouped:
        {
            type: Boolean,
            default: false,
        },

        focus:
        {
            type: [Function, Boolean],
            default: false,
        },

        blur:
        {
            type: [Function, Boolean],
            default: false,
        },

        disabled:
        {
            type: Boolean,
            default: false,
        },

        defaultValue:
        {
            type: String,
            default: '—'
        },

        keepDefault:
        {
            type: Boolean,
            default: false,
        },
    },

    computed:
    {
        showDefault()
        {
            if (this.defaultValue && this.keepDefault) return true;
            return (this.selected == null && typeof _.find(this.items, (item) => { return item == this.defaultValue }) == 'undefined')
        },

        classObject()
        {
            let _class = {};

            if (this.open)
                _class['is-open'] = true;

            if (this.disabled)
                _class['disabled'] = true;

            if (this.style !== '' && !this.noBorder)
                _class[this.style] = true;

            return _class;
        },

        display()
        {
            if (this.grouped)
            {
                for (let i in this.items)
                {
                    let label = _.find(this.items[i], { value: this.select });
                    if (label) return label.label || this.defaultValue;
                }
            }
            else
            {
                return this.items[this.select] || this.defaultValue;
            }
        },
    },

    methods:
    {
        /**
         * Select item
         *
         * @param key, key of selected item
         * @param {Boolean} silent, if event should be send or not
         */
        selectItem(key, silent)
        {
            this.$emit('changed', key);
        },

        /**
         * Close dropdown
         */
        closeEsc(e)
        {
            if (e.keyCode == 27)
                this.toggle();
        },

        /**
         * Toggle open state
         */
        toggle()
        {
            this.open = !this.open;

            if (this.open)
            {
                window.addEventListener('keyup', this.closeEsc, false);
            }
            else
            {
                window.removeEventListener('keyup', this.closeEsc, false);
            }
        },

        focusHandler()
        {
            (typeof this.focus === 'function')? this.focus() : null;
        },

        blurHandler()
        {
            (typeof this.blur === 'function')? this.blur() : null;
        }
    },

    watch:
    {
        select:
        {
            handler(val, oldVal)
            {
                this.selected = val;
            },

            immediate: true,
        }
    }
}
</script>



// WEBPACK FOOTER //
// Dropdown.vue?8e804896